import { render } from "./TheToast.vue?vue&type=template&id=67dfdcdc"
import script from "./TheToast.vue?vue&type=script&lang=js"
export * from "./TheToast.vue?vue&type=script&lang=js"
script.render = render

export default script